import { BASE_UNIT } from 'ms-styles/theme/Numero';

export const HORIZONTAL_PADDING = BASE_UNIT * 6;
export const MIN_SCREEN_WIDTH_FOR_SIDEBAR = 1024;
export const MAX_SCREEN_WIDHT_FOR_FULL_SCREEN_FLYOUT = 420;
export const LEFT_ASIDE_ELEMENT_VERTICAL_PADDING = BASE_UNIT * 5;
